
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100%","height":"100%","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 5.96a.874.874 0 00-.04-.18v-.06a.714.714 0 00-.127-.186l-4-4a.713.713 0 00-.186-.127.213.213 0 00-.06 0 .587.587 0 00-.22-.074h-2.7a2 2 0 00-2 2V4H4a2 2 0 00-2 2v6.667a2 2 0 002 2h5.333a2 2 0 002-2V12H12a2 2 0 002-2V6v-.04zm-4-2.353l1.727 1.726h-1.06A.667.667 0 0110 4.667v-1.06zm0 9.06a.667.667 0 01-.667.667H4a.666.666 0 01-.667-.667V6A.667.667 0 014 5.333h.667V10a2 2 0 002 2H10v.667zM12.667 10a.667.667 0 01-.667.667H6.667A.667.667 0 016 10V3.333a.667.667 0 01.667-.666h2v2a2 2 0 002 2h2V10z","fill":"currentColor"}})])
          )
        }
      }
    